const updates = [
  { date: '08-01', title: '《玫瑰的故事》全38集更新完毕', tag: '新剧完结', accent: true },
  { date: '07-31', title: '《你比星光美丽》更新至第32集', tag: '热播中' },
  { date: '07-31', title: '《唐朝诡事录之西行》更新至第28集', tag: '高分推荐' },
  { date: '07-30', title: '《长相思》第二季全集上线', tag: '新剧完结', accent: true },
  { date: '07-29', title: '韩剧《好搭档》更新至第6集', tag: '韩剧上新' },
  { date: '07-28', title: '《孤战迷城》更新至第40集大结局', tag: '大结局' },
  { date: '07-27', title: '《四海重明》更新至第14集', tag: '热播中' },
  { date: '07-26', title: '《少年白马醉春风》更新至第20集', tag: '国漫改编' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          更新快讯
        </h2>
        <div className="max-w-2xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-4 py-4 border-b border-background-200/70 last:border-0 group cursor-pointer ${
                item.accent ? 'bg-accent-50/60 -mx-4 px-4 rounded-lg' : ''
              }`}
            >
              <span className="text-xs font-medium text-foreground-500 whitespace-nowrap mt-0.5 w-12 shrink-0">
                {item.date}
              </span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors duration-150 leading-relaxed">
                {item.title}
              </span>
              <span className={`shrink-0 text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap ${
                item.accent
                  ? 'bg-accent-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}